import { Check, X } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Shared";

const PAINS = [
  "Growth depends on referrals and luck",
  "Hours lost to manual prospecting",
  "Agencies that don't understand recruitment",
];

const GAINS = [
  "A consistent outbound pipeline, built for you",
  "Personalized outreach to your ideal buyers",
  "Qualified meetings booked to your calendar",
];

export const ProblemSolution = () => (
  <section className="py-20 sm:py-28 border-t border-[#F0EBF8]" data-testid="problem-solution-section">
    <div className="max-w-6xl mx-auto px-6">
      <SectionHeading
        eyebrow="The problem"
        title="Great recruiters shouldn't have to prospect."
        sub="Most IT recruitment firms grow on referrals and inbound luck. When placements slow, business development gets squeezed between interviews. We run the outreach so you can book 10+ qualified sales meetings every month — without paid ads or hiring SDRs."
      />
      <Reveal delay={0.15} className="mt-8 flex flex-wrap justify-center gap-2.5">
        {["2 channels: LinkedIn + Email", "No paid ads", "No SDRs to hire"].map((chip) => (
          <span
            key={chip}
            data-testid={`problem-chip-${chip.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="rounded-full border border-violet-200 bg-[#EDEDF1] px-4 py-2 text-sm font-medium text-violet-800"
          >
            {chip}
          </span>
        ))}
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        <Reveal>
          <div className="h-full rounded-3xl border border-[#E9E4F0] bg-[#EDEDF1] p-8" data-testid="problem-card">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#6B5CA5]">The old way</p>
            <ul className="mt-6 space-y-4">
              {PAINS.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#F3F0F9] text-[#6B5CA5]">
                    <X className="h-3 w-3" />
                  </span>
                  <span className="text-base text-[#6B5CA5]">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="h-full rounded-3xl border border-violet-200 bg-[#EDEDF1] p-8" data-testid="solution-card">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-violet-700">The GrowRx way</p>
            <ul className="mt-6 space-y-4">
              {GAINS.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-violet-700 text-white">
                    <Check className="h-3 w-3" />
                  </span>
                  <span className="text-base font-medium text-[#3B0764]">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
